export default {
  title: 'GGMOMOMO COIN',
  tokenName: 'GGMOMOMO COIN',
  description: 'GGMOMOMO 是由 PUF 平台發行的 Meme Coin，連結 GGMOMOMO 遊戲生態的重要鏈上神秘資產。\n\nGGMOMOMO 並沒有被設定為單一遊戲的功能型代幣。它的角色更廣泛地圍繞整個 GGMOMOMO 遊戲生態，並會隨著更多遊戲、應用與玩家加入而逐步發揮作用。\n\n現階段，GGMOMOMO 的最終用途仍是未知狀態。我們希望隨著生態成長自然形成屬於自己的定位與保留無限可能性。',
  buyGgmomomo: '購買GGMOMOMO',
  openInfo: '開啟 GGMOMOMO 說明',
  close: '關閉 GGMOMOMO 說明',
} as const;
